module.exports = __webpack_public_path__ + "static/media/new_project.10b23656.png";